import { Breadcrumbs, Link, Typography } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { Col, Container, Pagination, Row } from "react-bootstrap";
import "../../../Assets/css/mjstatic.css";
import Gallery from 'react-photo-gallery';
import axios from "axios";
import { base_url, postHeader } from "../../../Helpers/request";
import { toast } from "react-toastify";
import { useHistory } from "react-router-dom";
import { Helmet } from "react-helmet";
import { NavLink } from 'react-router-dom';
import { useSelector } from "react-redux";
import moment from "moment";
import ArrowBlack from '../../../Assets/images/arrowcircleright2.svg';

const Blog = () => {
    const [bloglist, setBloglist] = useState([]);
    const [blogcategory, setBlogCategory] = useState([]);
    const [photos, setPhotos] = useState([]);
    const [category, setCategory] = useState('');
    const history = useHistory();
    const metaDetails = useSelector(state => state.persistedReducer.meta.meta)

    const [currentPage, setCurrentPage] = useState(1);
    const [blogPerPage, setBlogPerPage] = useState(12);
    const pageNum = [...Array(Math.ceil(bloglist.length / blogPerPage) + 1).keys()].slice(1);

    useEffect(() => {
        list();
        axios.get(base_url + '/common/blog_category', {
            headers: postHeader
        })
            .then(res => {
                if (res.data.status == 1) {
                    setBlogCategory(res.data.data)
                }
            })
            .catch((error) => {
                console.log(error);
            });
    }, [])
    useEffect(() => {
        list();
    }, [category])
    const list = () => {
        axios.post(base_url + '/common/blog_list', { category_id: category }, {
            headers: postHeader
        })
            .then(res => {
                if (res.data.status == 1) {
                    var list = [];
                    setBloglist(res.data.data)
                    res.data.data?.map(val => {
                        list.push({ id: val.blog_url, src: val.blog_image, height: val.height, width: val.width })
                    })
                    setPhotos(list);
                }
            })
            .catch((error) => {
                console.log(error);
            });
    }
    const [value, setValue] = React.useState('');
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const lastBlog = currentPage * blogPerPage;
    const firstBlog = lastBlog - blogPerPage;
    const currentBlogs = bloglist.slice(firstBlog, lastBlog);

    const onPrevPage = () => {
        if(currentPage !== 1) {
            setCurrentPage(currentPage - 1);
            window.scrollTo(0, 50);
        }
    };

    const onNextPage = () => {
        if(currentPage !== pageNum.length) {
            setCurrentPage(currentPage + 1);
            window.scrollTo(0, 50);
        }
    };
    return (
        <>
            <Helmet>
                <meta charSet="utf-8" />
                <title>{metaDetails.title}</title>
                <meta name="description" content={metaDetails.description} />
                <meta name="keywords" content={metaDetails.keywor}></meta>
        <link rel="canonical" href="https://swalesdiamonds.co.uk/blog" />
            </Helmet>
            {/* <div className="rcs_cart_section mt-3">
                <Container>
                    <Row>
                        <Col className="rcs_breadcrumb mb-2">
                            <Breadcrumbs aria-label="breadcrumb">
                                <NavLink underline="hover" color="inherit" to="/">
                                    Home
                                </NavLink>
                                <Typography color="text.primary">Blog</Typography>
                            </Breadcrumbs>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <din className="rcs_top_heading">
                                <h1>Our Blog</h1>
                            </din>
                        </Col>
                    </Row>
                </Container>
            </div>
            <div className="rcs_education_cotnent_pages rcs_education_cotnent_pages_blog">
                <Container>
                    <Row className="w-100 m-auto">
                        <Box sx={{ width: '100%', typography: 'body1' }}>
                            <TabContext value={value}>
                                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                                    <TabList onChange={handleChange} aria-label="lab API tabs example">
                                        <Tab label="All" value="" onClick={() => setCategory('')} />
                                        {blogcategory?.map(val =>
                                            <Tab label={val.name} value={val.category_id} onClick={() => setCategory(val.category_id)} />
                                        )}
                                    </TabList>
                                </Box>
                                <TabPanel value={category}>
                                    <Row className="w-100 m-auto">
                                        <Col className="p-0">
                                            <Gallery photos={photos} onClick={(e) => history.push('/blog-details/' + e.target.id)} />
                                        </Col>
                                    </Row>
                                </TabPanel>
                            </TabContext>
                        </Box>
                    </Row>
                </Container>
            </div> */}
            <div className="rcs_cart_section blog-breadcrumb mt-5">
                <Container>
                    <Row>
                        <Col>
                            <din className="rcs_top_heading m-0 text-center">
                                <h1 className="m-0">Our Blog</h1>
                                <div className="rcs_breadcrumb mt-2 d-flex align-items-center justify-content-center">
                                    <Breadcrumbs>
                                        <NavLink underline="hover" color="inherit" to="/">
                                            Home
                                        </NavLink>
                                        <Typography color="text.primary">Blog</Typography>
                                    </Breadcrumbs>
                                </div>
                            </din>
                        </Col>
                    </Row>
                </Container>
            </div>
            <div className="rcs_education_cotnent_pages rcs_education_cotnent_pages_blog mt-5">
                <Container>
                    <Row className="w-100 m-auto">
                        {
                            currentBlogs.map(blog => <Col xl={4} lg={6} md={6} key={blog.id}>
                                <div className="blog-item">
                                    <span><img style={{cursor: "pointer"}} onClick={() => history.push(`/blog-details/${blog.blog_url}`)} src={blog.blog_image} alt={blog?.blog_name} /></span>

                                    <div className="content">
                                        <Row>
                                            <Col>
                                                <NavLink to={`/blog-details/${blog.blog_url}`}><h5 className="category">{blog.category_name || "Jewelry"}</h5></NavLink>
                                            </Col>
                                            <Col>
                                                <p className="author m-0">{`By ${blog.author_name || "Admin"}`}</p>
                                            </Col>
                                        </Row>
                                        <NavLink className="mt-3 w-100" to={`/blog-details/${blog.blog_url}`}>{blog.blog_name}</NavLink>
                                        <div className="d-flex justify-content-between align-items-center">
                                            {/* formate of the date could be remove when formate should be mm-dd-yy */}
                                             {blog?.publish_date && <p className="pub-date m-0">{moment(blog?.publish_date, "DD-MM-YYYY").format("MMMM DD, YYYY")}</p>}
                                            <NavLink to={`/blog-details/${blog.blog_url}`}><img className="m-0" src={ArrowBlack} alt="" /></NavLink>
                                        </div>
                                    </div>
                                </div>
                            </Col>)
                        }
                    </Row>

                    <Pagination className="pagination-blog list-unstyled justify-content-center" >
                        <Pagination.Prev onClick={onPrevPage} />
                        {pageNum.map(num => <Pagination.Item className={currentPage === num ? 'active' : null} onClick={() => {setCurrentPage(num); window.scrollTo(0, 60)}}>{num}</Pagination.Item>)}
                        <Pagination.Next onClick={onNextPage} />
                    </Pagination>
                </Container>
            </div>
        </>
    );
}

export default Blog;